import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { VCustomerTerminalMain } from 'src/app/models/entities/v-customer-terminal-main';
import { CustomerTerminalMainService } from 'src/app/services/customer-terminal-main.service';
import * as FileSaver from 'file-saver';
import { formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer-terminal',
  templateUrl: './customer-terminal.component.html',
  styleUrls: ['./customer-terminal.component.css']
})
export class CustomerTerminalComponent implements OnInit {

  destroy$ = new Subject<void>();
  customerTerminals$: Observable<VCustomerTerminalMain[]>;
  deleteModal: boolean;
  ctmId: number;
  exportDatas: any[] = [];
  loading: boolean;
  @ViewChild('dt', { static: false }) dt: any;



  constructor(private customerTerminalMainService: CustomerTerminalMainService,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.loading = true;
    this.exportDatas = [];
    this.customerTerminals$ = this.customerTerminalMainService.getList().pipe(map(result => result.data), finalize(() => this.loading = false));
    this.customerTerminalMainService.getList().pipe(takeUntil(this.destroy$)).subscribe(result => {
      for (let index = 0; index < result.data.length; index++) {
        const element = result.data[index];
        this.exportDatas.push(
          {
            "Platform Adı": element.portalName,
            "Müşteri Kodu": element.customerCode,
            "Müşteri Adı": element.customerName,
            "Proje Adı": element.projectName,
            "Abonelik Tipi": element.contractTypeName,
            "Terminal Sayısı": element.numberOfTerminals,
            "Bayi Adı": element.dealerName
          }
        )
      }
    })
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showDeleteModal(ctmId: number) {
    this.deleteModal = true;
    this.ctmId = ctmId;
  }

  deleteCustomerTerminal() {
    this.deleteModal = false;
    this.customerTerminalMainService.delete(this.ctmId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportDatas);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Müşteri-Terminal");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + ' ' + formatDate(new Date, 'dd-MM-yyyy', 'en') + EXCEL_EXTENSION);
  }

}
